export default __webpack_public_path__ + "static/funeral-03a5b66e31c281b788fab1cf23ad6718.svg";